<template>
  <div class="app-container container-xxl my-10 pt-10">
    <h1>Terms of Use</h1>
    <p>
      All access and use of
      <a href="https://prosperafrica.asokoinsight.com"
        >prosperafrica.asokoinsight.com</a
      >
      (the “Site”) is subject to the terms and conditions set forth below
      (“Terms”). Any use of such web pages constitutes the user’s agreement to
      abide by the Terms. We may at any time by posting the amended terms on
      this site.
    </p>

    <h4>License and site access</h4>
    <p>
      Based on your compliance with the Terms, CrossBoundary LLC (CrossBoundary)
      grants you a revocable, non-transferable, limited license to access and
      make personal use of the Site and any content from the Site (the “Site
      Content”), subject to the terms. This site and any portion hereof may not
      be reproduced, duplicated, copied, licensed, sublicensed, published,
      downloaded, sold, resold, redistributed and/or otherwise exploited for any
      commercial purpose without the express written consent of CrossBoundary.
      You may not frame or utilize framing techniques to enclose any trademark,
      logo or other proprietary information (including images, text, page layout
      and form) of CrossBoundary and/or its affiliates without the express
      written consent of CrossBoundary. You may not use any meta tags or any
      other “hidden text” utilizing CrossBoundary’s name or Marks without the
      express written consent of CrossBoundary. Any unauthorized use terminates
      the license granted by CrossBoundary.
    </p>

    <h4>Copyright</h4>
    <p>
      All Site Content is owned by, licensed to, or lawfully used by
      CrossBoundary and/or its affiliates and protected by international
      copyright laws, as applicable. CrossBoundary and its licensors retain all
      proprietary rights to the Site Content. The Site Content may not be
      reproduced, transmitted or distributed without the prior written consent
      of CrossBoundary.
    </p>

    <h4>Trademarks</h4>
    <p>
      The trademarks, service marks, trade names and logos on this site are
      trademarks of CrossBoundary and/or its partners.
    </p>

    <h4>Privacy</h4>
    <p>
      Please review CrossBoundary’s Privacy Statement, which also governs your
      visit to
      <a href="https://prosperafrica.asokoinsight.com"
        >prosperafrica.asokoinsight.com</a
      >, to understand our practices.
    </p>

    <h4>Electronic Communications</h4>
    <p>
      When you visit the Site or send e-mails to us, you are communicating with
      us electronically. You consent to receive communications from us
      electronically. We will communicate with you by e-mail or by posting
      notices on this site. You agree that all agreements, notices, disclosures
      and other communications that we provide to you electronically satisfy any
      legal requirement that such communications be in writing.
    </p>

    <h4>Disclaimer of warranties and limitation of liability</h4>
    <p>
      This Site is provided by CrossBoundary on an “as is” and “as available”
      basis. CrossBoundary makes no representations or warranties of any kind,
      express or implied, as to the operation of this site, or the information,
      content or materials included on this site. You expressly agree that your
      use of this site is at your sole risk.
    </p>
    <p>
      The content and information captured in the Virtual Deal Room is for
      informational purposes only, and nothing contained therein should be
      construed or implied to constitute consent, support or investment
      recommendations for any company or transaction, by the U.S. Government or
      its implementing partners.
    </p>

    <h2>Privacy Statement</h2>
    <br />
    <h4>Data Controller and Owner</h4>
    <p>
      CrossBoundary LLC,
      <a href="mailto:dealroom@crossboundary.com">dealroom@crossboundary.com</a>
    </p>
    <p>
      Asoko Insight Limited,
      <a href="mailto:dealroom@crossboundary.com">dealroom@crossboundary.com</a>
    </p>
    <p>
      This Privacy Statement relates solely to the online information collection
      and use practices of our Web site located at
      <a href="https://prosperafrica.asokoinsight.com"
        >prosperafrica.asokoinsight.com</a
      >
      (the “Site”). We recognize that many visitors and users of this Web Site
      are concerned about the information they provide to us, and how we treat
      that information. This Privacy Statement, which may be updated from time
      to time, has been developed to address those concerns.
    </p>
    <p>
      Your use of this Web Site indicates to us that you have read and accept
      our privacy practices, as outlined in this Privacy Statement. If you have
      any questions or concerns regarding this Privacy Statement, please
      contact:
      <a href="mailto:dealroom@crossboundary.com">dealroom@crossboundary.com</a
      >.
    </p>
    <h4>What Information About You Do We Collect?</h4>
    <p>
      When you visit the Site, you may provide us with two types of information:
    </p>
    <p>
      (1) personally identifiable information that you knowingly choose to
      disclose, which is collected on an individual basis, and
    </p>
    <p>
      (2) general user information that does not contain personally identifiable
      information, which is collected on an aggregate basis as you browse the
      Site.
    </p>
    <p>
      In some cases, if you choose not to provide us with requested information,
      you may not be able to access all of the Site’s content or services.
    </p>
    <p>Personally Identifiable Information You Choose to Provide.</p>
    <p>
      We may ask for certain personal information from you for the purpose of
      providing to you content and/or services that you request. For example, if
      you indicate an interest in receiving follow up information about the
      Prosper Africa Deal Room, you are asked to submit your name and E-mail
      address, which we retain on file, so that we may send you the information
      that you requested. We also request your name and e-mail address each time
      you contact us by clicking on the “Contact Us” link. We may retain a
      record of users who have contacted us in order to respond properly to
      questions or concerns and for purposes of future communications.
    </p>
    <ul>
      <li>
        Contact form (This Application) By filling in the contact form with
        their Data, the User authorizes this Application to use these details to
        reply to requests for information, quotes or any other kind of request
        as indicated by the form’s header.
        <br />
        Personal Data collected: company name, country, email address, first
        name and last name.
      </li>
      <li>
        Mailing List or Newsletter (This Application) By registering on the
        mailing list or for the newsletter, the User’s email address will be
        added to the contact list of those who may receive email messages
        containing information of commercial or promotional nature concerning
        this Application. Your email address might also be added to this list as
        a result of signing up to this Application or after making a purchase.
        <br />
        Personal Data collected: email address, first name and last name.
      </li>
    </ul>
    <br />
    <h4>Non-Personally Identifiable Information We Collect.</h4>
    <ul>
      <li>
        Cookies / Web server logs: Similar to other commercial Web sites, the
        Site utilizes standard technology called “cookies” and Web server logs
        to collect information about how the Site is used. Cookies are a feature
        of Web browser software that allows Web servers to recognize the
        computer used to access a Web site. Cookies are small pieces of data
        that are stored by a user’s Web browser on the user’s hard drive.
        Information gathered through cookies and Web server logs may include the
        date and time of visits, the pages viewed, time spent at our Web Site,
        and the Web sites visited just before and just after our Web Site. This
        information is collected on an aggregate basis. None of this information
        is associated with you as an individual.
      </li>
      <li>
        You can, of course, disable cookies on your computer by indicating this
        in the preferences or options menus in your browser. However, it is
        possible that some parts of our Web Site will not operate correctly if
        you disable cookies. You should consult with your browser’s
        provider/manufacturer if you have any questions regarding disabling
        cookies.
      </li>
      <li>
        Third Party Services: We may use services hosted by third parties, such
        as Google Analytics, to assist in providing our services and to help us
        understand how the Site is used. These services may collect information
        sent by a browser as part of a web page request, including IP addresses
        or cookies. If these third party services collect information, they do
        so anonymously and in the aggregate to provide information helpful to us
        such as website trends, without identifying individual visitors. Please
        see “Cookies” in the section above for information on how you can
        control the use of cookies on your computer.
        <ul>
          <li>
            Google Analytics (Google Inc.) - Google Analytics is a web analysis
            service provided by Google Inc. (“Google”). Google utilizes the Data
            collected to track and examine the use of this Application, to
            prepare reports on its activities and share them with other Google
            services.
            <br />
            Google may use the Data collected to contextualize and personalize
            the ads of its own advertising network.
            <br />
            Personal Data collCookies and Usage data
          </li>
          <li>
            Google Tag Manager (Google Inc.) - Google Tag Manager is an
            analytics service provided by Google Inc. Personal Data collected:
            Cookies and Usage data.
          </li>
        </ul>
      </li>
    </ul>

    <br />
    <h4>How Do We Use the Information We Collect?</h4>
    <ul>
      <li>
        We use your personally identifiable information to provide you with the
        information or content that you have requested, and, in some cases, to
        contact you about our programs, events, features or services related to
        the Prosper Africa Deal Room. If you no longer wish to receive this type
        of information from us, you may send us an email through our “Contact
        Us” link or use our E-mail Alert form to change your preferences; or
        follow the “unsubscribe” link provided in the e-mail that you receive.
      </li>
      <li>
        We use non-identifying information collected on the Site in the
        aggregate to better understand your use of the Site and to enhance your
        enjoyment and experience. For example, we may use the information to
        improve the design and content of the Site or to analyze the programs
        and services that we offer.
      </li>
      <li>
        We may employ other companies and individuals to perform functions on
        our behalf. Our employees, agents and contractors who have access to
        personally identifiable information are required to protect the
        information in a manner that is consistent with this Privacy Statement.
      </li>
      <li>
        We may provide personally identifiable and non-identifying information
        to the US Government Prosper Africa Executive Secretariat for purposes
        of facilitating two-way trade and investment between the United States
        and Africa.
      </li>
      <li>
        We may provide access to your personally identifiable information when
        legally required to do so, to cooperate with police investigations or
        other legal proceedings, to protect against misuse or unauthorized use
        of the Site, to limit our legal liability and protect our rights, or to
        protect the rights and safety of visitors to the Site or the public. In
        those instances, the information is provided only for that limited
        purpose.
      </li>
      <li>
        We will not share your personally identifiable information in ways
        unrelated to those described above without providing you with an
        opportunity to opt out of such use or otherwise prohibit such unrelated
        uses.
      </li>
    </ul>

    <br />
    <h4>How Do You Access And/Or Modify Your Information or Choices?</h4>
    <p>
      If you visit the Site and volunteer personally identifiable information,
      you may modify, update or delete such information by visiting the E-mail
      Alert area where you will have the opportunity to access and revise
      certain of your personally identifiable information, and to update your
      prefergarding what information you want to receive from us, or by clicking
      on the “Contact Us” link and sending us an e-mail. You should be aware,
      however, that it is not always possible to completely remove or modify
      information in our databases. In addition, please be aware that your
      ability to opt out from receiving marketing and promotional materials does
      not change our right to contact you regarding your use of our Web Site.
    </p>

    <h4>Data Security</h4>
    <p>
      We take reasonable steps to maintain the security of the personally
      identifiable information that we collect, including limiting the number of
      people who have physical access to our database servers, as well as
      installing electronic security systems that guard against unauthorized
      access. However, no data transmission over the Internet can be guaranteed
      to be completely secure. Accordingly, we cannot ensure or warrant the
      security of any information that you transmit to us, so you do so at your
      own risk.
    </p>

    <h4>Links</h4>
    <p>
      The Site contains links to third party sites as well as to other sites
      owned and/or operated by CrossBoundary and Asoko Insight. Please be aware
      that CrossBoundary and Asoko Insight are not responsible for the privacy
      practices of any third party sites.
    </p>
    <h4>Revision Date</h4>
    <p>This Privacy Statement was last revised in October of 2020.</p>

    <h4>Data Processing Definitions</h4>
    <br />
    <p>
      <b>Data Controller</b>: has the meaning set out in thProtection
      Legislation.
    </p>
    <p>
      <b>Data Protection Legislation</b>: means the Data Protection Act 1998 or
      as replaced by the General Data Protection Regulation (GDPR) and Data
      Protection Bill.
    </p>
    <p>
      <b>Data Subject</b>: an individual who is the subject of Personal Data.
    </p>
    <p>
      <b>Personal Data</b>: has the meaning set out in the Data Protection
      Legislation and relates only to person or any part of such personal data,
      in respect of which the Company is the Data Controller and in relation to
      which CrossBoundary or Asoko is providing services under this agreement.
    </p>
    <p>
      <b>Processing and process</b>: have the meaning set out in the Data
      Protection Legislation.
    </p>
    A reference to a statute or statutory provision is a reference to it as
    amended, extended or re-enacted from time to time. Clauses
    <ol>
      <li>
        <b>Data Processing</b>
        <ol>
          <li>
            The Company and CrossBoundary/Asoko (each a “party”, together the
            “parties”) acknowledge that of the Data Protection Legislation, the
            Company is the Data Controller and CrossBoundary/Asoko is the data
            processor in respect of any Personal Data.
          </li>
          <li>
            It is further acknowledged that the Company has provided the
            Personal Data expressly for the following two legitimate purposes:
            <ul>
              <li>
                (a) For its inclusion in the Prosper Africa Virtual Deal Room;
                and
              </li>
              <li>
                (b) So the Personal Data may be listed in CrossBoundary’s
                proprietary database of companies which shall be made available
                the Prosper Africa Executive Secretariat
              </li>
            </ul>
          </li>
          <li>
            The Company expressly acknowledges and agrees that CrossBoundary and
            Asoko intend to process the Personal Data as set out above and that
            such processing is necessary for the legitimate interests of the
            Company.
          </li>
          <li>
            CrossBoundary and Asoko shall process the Personal Data only in
            accordance with the Company’s instructions from time to time and
            shall not process the Personal Data purpose other than those
            expressly authorized by the Company under this Agreement or
            otherwise.
          </li>
        </ol>
      </li>
      <li>
        <b>Warranties</b>
        <ol>
          <li>
            Each party warrants to the other that it will process the Personal
            Data in compliance with all applicable laws, enactments,
            regulations, orders, standards and other similar instruments.
          </li>
          <li>
            CrossBoundary and Asoko warrants that, having regard to the state of
            technological development and the cost of implementing any measures,
            it will:
          </li>
          <li>
            <ul>
              <li>
                (a) take appropriate technical and organizational measures
                against the unauthorized or unlawful processing of Personal Data
                and against the accidental loss or destruction of, or damage to,
                Personal Data to ensure a level of security appropriate to:
                <ul>
                  <li>
                    (i) the harm that might result from such unauthorized or
                    unlawful processing ontal loss, destruction or damage; and
                  </li>
                  <li>(ii) the nature of the data to be protected.</li>
                </ul>
              </li>
              <li>
                (b) take reasonable steps to ensure compliance with those
                measures.
              </li>
            </ul>
          </li>
          <li>
            The Company warrants that it has the right and authority to provide
            the Personal Data to CrossBoundary and Asoko and that all
            information provided shall be complete and accurate.
          </li>
        </ol>
      </li>
      <li>
        <b>Indemnity</b>
        <ol>
          <li>
            Each party agrees to indemnify and keep indemnified and defend at
            its own expense the other party against all costs, claims, damages
            or expenses incurred by the other party or for which the other party
            may become liable due to any failure by the first party or its
            employees or agents to comply with any of its obligations under this
            agreement.
          </li>
          <li>
            The Company acknowledges that CrossBoundary and Asoko are reliant on
            the Company for direction as to the extent to which CrossBoundary
            and Asoko are entitled to use and process the Personal Data.
            Consequently, CrossBoundary and Asoko will not be liable for any
            claim brought by a Data Subject arising from any action or omission
            by CrossBoundary or Asoko, to the extent that such action or
            omission resulted directly from the Company's instructions.
          </li>
        </ol>
      </li>
    </ol>
  </div>
</template>

<style lang="scss" scoped></style>
